import React from 'react';

export const HeadingElement = ({ children, isFirstBlock, as = 'h1', style, ...props }) => {
  const { attributes, className } = props;
  const Element = as;
  return (
    <Element
      {...attributes}
      className={className}
      style={style}
    >
      {children}
    </Element>
  );
};
